import axiosapi from "../api/axiosapi";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const GradeFirstProblem = () => {
    const [contents, setContents] = useState('');
    const {topCategory} =useParams();
    const navigateTo = useNavigate();
    const {topCategoryTitle} = useLocation().state;
    const {auth, setAuth} = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect( () => {
        const controller = new AbortController();

        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        const fetchSubjectList = async () => {
            try {
                const response = await axiosapi.get('/subjectList', {state: {topCategory: topCategory}})
                response.data && setContents(response.data);
            } catch (err) {
                console.log(err)
            }
        }
        fetchSubjectList();
        
        return () => controller.abort();
    },[topCategory])

    return(
        <div>
            {contents && contents.slice(0,1).map(content => {
                return(
                    <div key={topCategory}>
                        {navigateTo(`/mathsubject/${content.categories[0].problems[0].idIn}`, {state: {
                            "problemTopCategory": content.topCategory,
                            "topCategoryTitle": topCategoryTitle
                        }})}
                    </div>
                )
            })}
        </div>
    )
}

export default GradeFirstProblem;